import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { catchError, switchMap, takeWhile } from 'rxjs/operators'
import { IngestContainerModel } from '../models/ingest-container.model'
import { BlobServiceClient } from '@azure/storage-blob'
import { Router } from '@angular/router'
import { BsModalService } from 'ngx-bootstrap/modal'
import { interval } from 'rxjs/observable/interval'
import { Subscription } from 'rxjs/Subscription'

@Injectable()
export class PictureParkService {

  private apiUrl = environment.api.url + environment.api.picturePark.url
  private pollingSubscription: Subscription

  constructor(private http: HttpClient, private router: Router, private modalService: BsModalService) {}

  initializeFileUpload(file: Blob, document: any) {
    return this.createIngestContainer().subscribe({
      next: async (response) => {
        const containerName = response.containerName
        const blobServiceClient = new BlobServiceClient(response.sasToken)
        const containerClient = blobServiceClient.getContainerClient(containerName)
        await containerClient.getBlockBlobClient(document.displayName).uploadData(file)
        this.startUpload(containerName).subscribe({
          next: (businessProcess: any) => {
            if (businessProcess) {
              this.isUploadFinished(businessProcess.id, document)
            }
          }
        })
      }
    })
  }

  /** Upload step 1 : create an azure blob storage container and put file into it **/
  createIngestContainer() {
    return this.http.get(this.apiUrl).map((response: any) => {
      const { sasToken, containerName } = response
      return new IngestContainerModel(sasToken, containerName)
    }, catchError(err => err))
  }

  /** Upload step 2: Import all files into pictures park from container name **/
  startUpload(containerName: string) {
    return this.http.get(this.apiUrl + `/upload/start?containerName=${containerName}`)
      .map((response: any) => {
        return response
      }, catchError(err => err))
  }

  /** Upload step 3: Call picture park multiple times to get the status of the current upload **/
  isUploadFinished(businessProcessId: string, document: any) {
    this.pollingSubscription = interval(5000)
      .pipe(
        switchMap(() => this.http.get<any>(this.apiUrl + `/upload/status?businessProcessId=${businessProcessId}`)),
        takeWhile((response: boolean) => {
          if (response) this.completeUpload(document).subscribe()
          return !response
        })
      ).subscribe((response:boolean) => {
        return response
      })
  }

  stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  /** Upload step 4: Saving document information into DB **/
  completeUpload(document: any) {
    return this.http.post(this.apiUrl, document).map((res: any) => {
      this.modalService.hide(1)
      if (res?.id) {
        this.stopPolling()
        this.router.navigateByUrl(`admin/competition/${res.parentId}/file/${res.id}`)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/picture-park.service.ts